import { render, staticRenderFns } from "./BookingHistory.vue?vue&type=template&id=66da0b16&scoped=true&"
import script from "./BookingHistory.vue?vue&type=script&lang=js&"
export * from "./BookingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da0b16",
  null
  
)

export default component.exports